import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultFormComponent } from './default-form/default-form';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng2FileInputModule, Ng2FileInputOptions } from 'ng2-file-input';
import { DefaultTableComponent } from './default-table/default-table';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { BrMasker4Module } from 'brmasker4';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_LOCALE } from '@angular/material';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { NgxViacepModule } from '@brunoc/ngx-viacep';
import { ExportFilesComponent } from './export-files/export-files.component';
import { FileUploadModule } from '@iplab/ngx-file-upload';


@NgModule({
	declarations: [
		DefaultFormComponent,
		DefaultTableComponent,
		ExportFilesComponent
	],
	imports: [
		BrMasker4Module,
		MatMomentDateModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		Ng2FileInputModule,
		ColorPickerModule,
		NgMultiSelectDropDownModule.forRoot(),
		MatFormFieldModule,
		MatButtonModule,
		MatInputModule,
		MatSelectModule,
		MatAutocompleteModule,
		MatCheckboxModule,
		MatRadioModule,
		MatDatepickerModule,
		NgxViacepModule,
		FileUploadModule
	],
	exports: [
		DefaultFormComponent,
		DefaultTableComponent,
		ExportFilesComponent,
		MatFormFieldModule,
		MatButtonModule,
		MatInputModule,
		MatSelectModule,
		MatAutocompleteModule,
		MatCheckboxModule,
		MatRadioModule,
		MatDatepickerModule,
	],
	providers: [
		Ng2FileInputOptions,
		{ provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class ComponentsModule { }
